import React, { useEffect } from 'react';
import { KodanshaNavbar } from '../KodanshaNavbar/KodanshaNavbar';
import { KodanshaFooter } from '../KodanshaFooter/KodanshaFooter';
import HeroImage from '../KodanshaAssets/404_IMG_2880x1040-scaled.jpeg';
import './KodanshaNotFound.scss';
import Log from '../Services/Logger';
import apiClient from '../../API/InkyAPI';
import AnalyticsEvent from '../../Models/Analytics/AnalyticsEvent';
import { useAtom } from 'jotai';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from '../../store/AnalyticsStore';
import { AccountInfoAtom } from '../../store/AccountStore';

export function KodanshaNotFound(): JSX.Element {

    const [analyticsId] = useAtom(AnalyticsIdAtom);
    const [accountInfo] = useAtom(AccountInfoAtom);
    const [analyticsUserProxy] = useAtom(AnalyticsUserProxyAtom);

    useEffect(() => {
        Log.debug('Page Not Found.');
        apiClient.sendEvent(accountInfo,new AnalyticsEvent(analyticsId.toString(),
            'NOT_FOUND',
            location.pathname, window.location.href, analyticsUserProxy.toString())).then(res => {
            //console.log(res.data);
        });
    }, []);

    return (
        <div>
            <KodanshaNavbar />
        <div>

            <div className={"not-found"}>
                <img className="hero-image" src={HeroImage} alt={'kodansha 404 Hero'} />
                <div className={"not-found-inner-wrapper"}>
                    <h1>404</h1>
                    <h2>Page Not Found</h2>
                    Possibly due to a name change, page removal, or the page being unavailable temporarily. Please check
                    back in a little bit. We hope to have this resolved soon.
                </div>
            </div>
        </div>
            <KodanshaFooter />
    </div>);
}